export default __webpack_public_path__ + "static/media/DJI_0895.MP4.00_00_24_14.Still003.a5d27dbd.jpg";